// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cf113d{filter:grayscale(100%)}._350f30{left:-100000em;position:absolute}", ""]);
// Exports
exports.locals = {
	"grayscale": "cf113d",
	"hide": "_350f30"
};
module.exports = exports;
